import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable, combineLatest, map, of } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { ProductLinks } from 'ish-core/models/product-links/product-links.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductCompletenessLevel } from 'ish-core/models/product/product.model';

@Component({
  selector: 'custom-suggested-for-you',
  templateUrl: './suggested-for-you.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestedForYouComponent {
  /**
   * list of products which are assigned to the specific product link type
   */
  @Input() links: ProductLinks;
  /**
   * title that should displayed for the specific product link type
   */
  @Input() productLinkTitle: string;
  /**
   * display only available products if set to 'true'
   */
  @Input() displayOnlyAvailableProducts = false;

  suggestedProducts$: Observable<ProductView[]>;

  constructor(private shoppingFacade: ShoppingFacade) {}

  ngOnChanges() {
    this.suggestedProducts$ = this.displayOnlyAvailableProducts
      ? combineLatest(
          this.links.products.map(sku => this.shoppingFacade.product$(sku, ProductCompletenessLevel.List))
        ).pipe(map(products => products.filter(p => p.available).map(p => p)))
      : of();
  }
  getClass(length: number): string {
    if (length === 1) {
      return 'suggest-fluid';
    } else if (length === 2) {
      return 'suggest-half';
    } else {
      return 'suggest-three';
    }
  }
}
